import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getTariffList } from 'services/tariffs-service';
import { Popup2, Confirm, Button, themes, ButtonContainer, SimpleSelect } from 'libs/ui';
import { AttentionIcon, Content, NewTicketHeader, NewTicketInfo } from './set-tariff.styled';

export const SetTariff = (props) => {
  const { t } = useTranslation();
  const [tariff, setTariffState] = useState('');
  const [tariffs, setTariffs] = useState([]);
  const [confirm, setConfirm] = useState(false);

  const out = { status: 'active' };
  if (window.config.central && props.parkingId) {
    out.parking_id = props.parkingId;
  }

  useEffect(() => {
    getTariffList(out, []).then((data) => {
      let selectedTariff = props.tariffId;

      if (data.items.length) {
        const found = data.items.some((el) => el.id === selectedTariff);
        if (!found) {
          selectedTariff = data.items[0].id;
        }
      }

      setTariffs(data.items);
      setTariffState(selectedTariff);
    });
  }, [props]);

  const showConfirmForm = () => {
    setConfirm(true);
  };

  const handleTariffChange = (event) => {
    setTariffState(event.target.value);
  };

  const getTariffs = () => {
    return tariffs.map((tariff) => (
      <option key={tariff.id} value={tariff.id}>
        {tariff.name}
      </option>
    ));
  };

  if (!tariffs.length) {
    return null;
  }

  const disabled = !tariff || (tariff && tariff === props.tariffId);

  return (
    <>
      <Popup2 w={480}>
        <AttentionIcon src="/images/exclamation.svg" alt="" />
        <Content>
          <NewTicketHeader>{t('form.Смена тарифа')}</NewTicketHeader>
          <NewTicketInfo style={{ marginBottom: '20px' }}>
            {t('form.Тариф')}
            <SimpleSelect onChange={handleTariffChange} width="245px" value={tariff}>
              {getTariffs()}
            </SimpleSelect>
          </NewTicketInfo>
          <ButtonContainer space="20px" justifyContent={'flex-start'}>
            <Button fontSize="16px" onClick={props.close}>
              {t('buttons.Отменить')}
            </Button>
            <Button disabled={disabled} theme={themes.blue} fontSize="16px" onClick={showConfirmForm}>
              {t('buttons.Заменить')}
            </Button>
          </ButtonContainer>
        </Content>
      </Popup2>
      {confirm && (
        <Confirm
          width={'550px'}
          title={t('form.Тарификация данной парковочной сессии будет изменена. Продолжить?')}
          type="danger"
          cancelButton={{
            text: t('buttons.Отменить'),
            func: () => {
              setConfirm(false);
            },
          }}
          acceptButton={{
            text: t('buttons.Заменить'),
            func: () => {
              setConfirm(false);
              props.action({ stayId: props.id, tariffId: tariff });
              props.close();
            },
            theme: themes.red,
          }}
        />
      )}
    </>
  );
};

SetTariff.propTypes = {
  id: PropTypes.any.isRequired,
  parkingId: PropTypes.any,
  tariffId: PropTypes.any.isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
};
